module.exports = __webpack_public_path__ + "img/img002.f0b9964a.png";